import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2cb9e087&scoped=true&"
import script from "./About.ts?vue&type=script&lang=ts&"
export * from "./About.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=2cb9e087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9e087",
  null
  
)

export default component.exports